<template>
    <div>
      404
    </div>
</template>
<script>
export default {
    data() {
      return{}
    },
    methods:{}
}
</script>
<style scoped>

</style>